import { render, staticRenderFns } from "./VerticalMenuBar.vue?vue&type=template&id=2020f5da&scoped=true"
import script from "./VerticalMenuBar.vue?vue&type=script&lang=ts"
export * from "./VerticalMenuBar.vue?vue&type=script&lang=ts"
import style0 from "./VerticalMenuBar.vue?vue&type=style&index=0&id=2020f5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020f5da",
  null
  
)

export default component.exports